module.exports = __webpack_public_path__ + "img/blog-details.2c6110d1.jpg";